export const style = {
   container: {
      height: '100%'
   },
   paper: {
      height: '100%',
      display: 'grid',
      marginLeft: '15px',
      paddingTop: 15
   },
   containerForm: {
      height: '100%',
      display: 'grid'
   },
   form: {
      width: '100%',
      display: 'grid',
      gridTemplateColumns: 'minmax(0, 1fr)',
      maxWidth: 350,
      maxHeight: 700
   },
   formControl: {
      width: '100%',
      minWidth: 120,
      textAlign: 'initial',
      fontSize: '14px'
   },
   submit: {
      marginTop: '10px',
      textTransform: 'none',
      width: '100%'
   },
   submitUpdate: {
      marginTop: '10px',
      textTransform: 'none',
      width: '100%',
      marginLeft: '-70px'
   },
   error: {
      '&.MuiFormHelperText-root.Mui-error': {
         color: 'red',
         marginTop: '-20px',
         paddingBottom: '0'
      },
      spacing: {
         marginBottom: '-15px'
      }
   },
   titleOne: {
      display: 'flex',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontSize: '16px',
      justifyContent: 'center',
      alignItems: 'center',
      lineHeight: '28px',
      letterSpacing: '-0.06px'
   },
   gridItem: {
      width: '95%',
      height: '100%'
   },
   recaptcha: {
      width: '100%',
      alignItems: 'center'
   },
   recaptchaError: {
      paddingLeft: 10,
      alignSelf: 'flex-start'
   }
}
